import { cloneElement } from 'react'
import { useTranslate, useRecordContext } from 'react-admin'

export const TranslateWrapperTextField = ({
  source,
  children,
  prefix,
  ...props
}) => {
  const translate = useTranslate()
  const record = useRecordContext()

  if (!record) return null
  const prev = record[source]
  if (record[source]) {
    let posfix = ''
    if ('contract' === record.document_type) posfix += '.contract'
    record[source] = translate(
      `${prefix ? prefix : 'resources'}.${source}${posfix}.${record[source]}`
    )
  }
  if (record[source] && record[source].indexOf(prefix) !== -1)
    record[source] = prev

  return cloneElement(children, {
    props,
    record,
    source,
  })
}
